<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import { Select } from "element-ui";
import { kydkpz_MXquery } from "../../../../../api/kydkpz.js";
import config from "../../../../../../configHttp.js";
export default {
  data: function () {
    return {
      bonindex: 0,
      bott: getdata().bott,
      shaidiag: false,
      headData: getdata().zzsData,
      outlist: [],
      searchdiag: false,
      searchlist: getdata().zzssearchlist,
      dateValue: "",
      searchdata: {},
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
      overlength: 0,
    };
  },
  mounted() {},
  components: {},
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
    tiaozgaodu() {},
    anniuleixingdianji(index) {
      this.bonindex = index;
      if (this.bonindex == 0) {
        this.headData = getdata().zzsData;
		this.searchlist=getdata().zzssearchlist;
      } else if (this.bonindex == 1) {
        this.headData = getdata().xcdData;
		this.searchlist=getdata().xcdsearchlist;
      } else if (this.bonindex == 2) {
        this.headData = getdata().glfData;
		this.searchlist=getdata().glfsearchlist;
      } else if (this.bonindex == 3) {
        this.headData = getdata().hcpData;
		this.searchlist=getdata().hcpsearchlist;
      } else if (this.bonindex == 4) {
        this.headData = getdata().czcData;
		this.searchlist=getdata().czcsearchlist;
      } else if (this.bonindex == 5) {
        this.headData = getdata().qcpData;
		this.searchlist=getdata().qcpsearchlist;
      } else if (this.bonindex == 6) {
        this.headData = getdata().defqData;
		this.searchlist=getdata().defqsearchlist;
      } else if (this.bonindex == 7) {
        this.headData = getdata().cpData;
		this.searchlist=getdata().cpsearchlist;
      }
	  this.fetchBillDetails()
	  this.$nextTick(()=>{
	  		  setTimeout(() => {
	  		  this.$refs.tablebox.dout();
	  		  }, 300);
	  })
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    submitSearch() {
      // this.pagination.pageNum = 1
      // this.pagination.paginationkey++
      // this.fetchBillDetails()
    },
    outPutIInvResult() {
		let selectVal = this.$refs.tablebox.getSelectionval();
		let data = {};
		data.tabtype=this.bonindex;
		if (selectVal.length > 0) {
		  data.ids = selectVal.map((item) => item.id).joio(",");
		} else {
		  data = JSON.parse(JSON.stringify(this.searchdata));
		}
		let params = {
		  downUrl: config.baseURL + "kydk/details/export",
		  typeObj: {
		    toForm: false,
		    fileName: "客运抵扣票据明细" + this.$timestampToStr(new Date(), "yyyyMMdd"),
		    fileType: "xlsx",
        failUrl:this.$winURl
		  },
		  params: data,
		};
		this.$downloadcommon(params);
	},
    forRefresh() {
		this.fetchBillDetails()
		},
    sizechange(e) {
      this.pagination.pageSize = e;
       this.fetchBillDetails()
    },
	//查询
    fetchBillDetails() {
		let params={};
		params = this.searchdata;
		params.current = this.pagination.pageNum;
		params.size = this.pagination.pageSize;
		params.tabtype =this.bonindex;
		kydkpz_MXquery(params).then(res => {
		   this.tableData = res.data.data.records
		  this.pagination.total = res.data.data.total
		})
	},
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchBillDetails()
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
       this.fetchBillDetails()
    },
  },
  created() {
	  this.fetchBillDetails();
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
